// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__qmBhA","sendOtp":"AuthorizeToLogin_sendOtp__4OCrf"};